$(document).on('click', '.faq-question', function () {
    const item = $(this).closest('.faq-item');

    $('.faq-item').not(item).removeClass('open')
        .find('.faq-answer').slideUp(250);

    item.toggleClass('open');
    item.find('.faq-answer').slideToggle(250);

    // 👇 scroll až po animaci
  /*  setTimeout(() => {
        const stickyHeight = $('.col-sm-12.shp-tabs-row.responsive-nav.stickyTabs').outerHeight() || 0;

     /*   $('html, body').animate({
            scrollTop: item.offset().top - stickyHeight - 10 // malý offset navíc
        }, 300);*/
   // }, 260); // o chlup víc než slideToggle
});

$(document).on('click', '.faqVideo[data-video]', function () {
    const $thumbnail = $(this);
    const videoId = $thumbnail.attr('data-video');
    const $player = $('<div class="faqVideo faqVideo--playing"><iframe src="https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0" title="YouTube video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe></div>');

    $thumbnail.after($player).detach();
    $player.data('thumbnail', $thumbnail);
});

$(document).on('click', '.faq-question', function () {
    $('.faq-item:not(.open) .faqVideo--playing').each(function () {
        $(this).replaceWith($(this).data('thumbnail'));
    });
});